import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import "../../styling/sidebar.css";
import "../../styling/expensepop.css";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { CircularProgress } from "@material-ui/core";
import Select from "@mui/material/Select";
import Modal from "react-bootstrap/Modal";
import GetUser from "../../services/get-user";
import { makeStyles } from "@material-ui/core";
import { toast } from "react-toastify";
import { isArray } from "lodash";
import moment from "moment";

const user = GetUser();
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
interface CsvWithAdvanceOptionSaleProps {
  csvFileRecords: any[],
  openModal:boolean,
  setOpenModal:(any) => void,
  stream:any,
  setReloadAPI:(any) => void,
  closeSaleModal?:(any) => void;
}

const CsvWithAdvanceOptionSale: React.FC<CsvWithAdvanceOptionSaleProps> =
 ({ csvFileRecords, openModal, setOpenModal, stream,setReloadAPI ,closeSaleModal})=> {
  const [csvObjestKeys, setCsvObjectKeys] = useState({});
  const [payloadColumn, setPayloadColumn] = useState<string[]>([]);
  const advancedFormField = ['name', 'amount', 'date', 'customer', 'fee', 'note']
  const [loading, setLoading] = useState(false);
  const [isFileUploaded,setIsUploadedFile]=useState(false)
  const useStyles = makeStyles({
    selected: {
      border: "1px solid green !impoortant",
      color: "#48b7a7 !important",
    },
  });
  const classes = useStyles();

  useEffect(() => {
    if (csvFileRecords?.length && isArray(csvFileRecords[0])) {
      var data = {};
      csvFileRecords[0].forEach((value) => {
        data[value === "purchased from" ? "site" : ""] = "";
      });
      setCsvObjectKeys(data);
    }
  }, [csvFileRecords]);

  const handleChange = (event) => {
    !payloadColumn.includes(event.target.name) && 
      setPayloadColumn([...payloadColumn, event.target.name]);
    let copyObj = { ...csvObjestKeys };
    copyObj[event.target.name] = event.target.value.trim();
    setCsvObjectKeys(copyObj);
  };

  const getCsvObject = (newValueIndex: any) => {
    let data = {};
    csvFileRecords[0].forEach((value, index) => {
      data[value.trim() === "purchased from" ? "site" : value.trim()] =
        csvFileRecords[newValueIndex][index];
    });
    return data;
  };

  const handleImportCsv = () => {
    setLoading(true)
    var isValidated = true;
    let requestPayload :any[]= [],data; 
    requestPayload.push(advancedFormField)
    if (!payloadColumn.includes("name")) {
      isValidated = false;
      toast.error("name is required");
    } 
    if (!payloadColumn.includes("customer")) {
      isValidated = false;
      toast.error("customer is required");
    } 
    if (!payloadColumn.includes("amount")) {
      isValidated = false;
      toast.error("amount is required");
    } 
   
    for (let i = 1; i <= csvFileRecords.length - 1; i++) {
      data = getCsvObject(i); 
      let result :any []= [];
      for (const key of advancedFormField) {
        if(!payloadColumn.includes(key)){ 
            key !== 'date' ? result.push('') : result.push(new Date());
        }
        else{
          if(key === "date"){
            if(!moment(data[csvObjestKeys["date"]]).isValid()){
              result.push(moment().format("MMM DD yyyy"))
            }
            else{
              const newDate = data[csvObjestKeys["date"]]
              ? moment(data[csvObjestKeys["date"]]).format("MMM DD yyyy")
              : moment().format("MMM DD yyyy");
              result.push(newDate)
            }
          }
          else if(key === "amount") {
            const typeAmount = typeof data[csvObjestKeys["amount"]] 
            if(typeAmount === 'object'){
              isValidated = false;
              toast.error("amount should be number");
              break;
            }
            const amount = data[csvObjestKeys["amount"]] && 
                          (typeAmount === 'string' &&  data[csvObjestKeys["amount"]].startsWith("$"))? data[csvObjestKeys["amount"]].replaceAll(",","").split("$").join("").trim() : data[csvObjestKeys["amount"]];
             if(isNaN(amount) || !amount){
              isValidated = false;
              toast.error("amount should be number");
              break;
            }else{
              result.push(Number(amount))
            }
          }
          else if(key === "fee") {
            if(data[csvObjestKeys["fee"]]===undefined){
              const fees ='';
              result.push(fees);
            }
            else{
              const typeFee = typeof data[csvObjestKeys["fee"]]; 
              if(typeFee === 'object'){
                isValidated = false;
                toast.error("fee should be number");
                break;
              }
              const fees = data[csvObjestKeys["fee"]] && 
                          (typeFee === 'string' &&  data[csvObjestKeys["fee"]].startsWith("$"))? data[csvObjestKeys["fee"]].replaceAll(",","").split("$").join("").trim() : data[csvObjestKeys["fee"]];
              if(isNaN(fees) || !fees){
                  isValidated = false;
                  toast.error("fee should be number");
                  break;
              }else{
                  result.push(Number(fees))
              }
            }
          }
          else{
            result.push(data[csvObjestKeys[key]]? data[csvObjestKeys[key]]:"")
           }
        }
      }
      if(!isValidated){
        break;
      }
      requestPayload.push(result);
    }
    if(!isValidated){
      setLoading(false);
    }
    const Timeout=setTimeout(() => {
      if(!isFileUploaded){
      toast.info(<p> Email your file to <a href="mailto:support@sotira.co">support@sotira.co </a>and we will upload it for you</p>)
    }
    else{
      setIsUploadedFile(true)
      clearTimeout(Timeout)
    }
    }, 20000);

    try {
      if (isValidated) {
        return axios
          .post(
            "https://sotira-back-test.herokuapp.com/sale/add_csv_sale",
            {
              userID: user.userID,
              incomeStream: stream + 1,
              sales: requestPayload,
            }
          )
          .then((response) => {
            clearTimeout(Timeout)
            sessionStorage.setItem("option", "sales");
            setOpenModal(false);
            setLoading(false);
            closeSaleModal && closeSaleModal(false);
            setReloadAPI((prevState)=>!prevState)
          });
      }
    } catch (e: any) {
      setLoading(false);
      alert(e.response.data);
    }
  };

  return (
    <>
      <Modal
        show={openModal}
        backdrop="static"
        keyboard={false}
        className="csv-modal"
      >
        <Modal.Header
          closeButton
          onClick={() => {
          setOpenModal(false);
          }}
        ><div >
        <div>
        <Modal.Title>Import CSV/Excel</Modal.Title>
        </div>
        <p >Match your column names to the columns that we provide</p>
        </div>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-around flex-column">
            <div className="d-flex mx-4 my-2 justify-content-between">
              <div>Name</div>
              <div>
                <FormControl sx={{ width: 200 }} required defaultValue="name">
                  <InputLabel id="demo-simple-select-label">Name</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Name"
                    name="name"
                    onChange={handleChange}
                    className="h-50"
                  >
                    {csvFileRecords[0].map((item) => (
                      <MenuItem
                        value={item}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="d-flex mx-4 my-2 justify-content-between">
              <div>Amount</div>
              <div>
                <FormControl sx={{ width: 200 }} required defaultValue="amount">
                  <InputLabel id="demo-simple-select-label">Amount</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Amount"
                    name="amount"
                    onChange={handleChange}
                  >
                    {csvFileRecords[0].map((item) => (
                      <MenuItem
                      value={item}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="d-flex mx-4 my-3 justify-content-between">
              <div>Date</div>
              <div>
                <FormControl sx={{ width: 200 }} defaultValue={0}>
                  <InputLabel id="demo-simple-select-label">Date</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Date"
                    name="date"
                    onChange={handleChange}
                  >
                    <MenuItem value="None">None</MenuItem>
                    {csvFileRecords[0].map((item) => (
                      <MenuItem
                        value={item}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="d-flex mx-4 my-2 justify-content-between">
              <div>Customer Name</div>
              <div>
                <FormControl sx={{ width: 200 }} required defaultValue="name">
                  <InputLabel id="demo-simple-select-label">Customer</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="customer"
                    name="customer"
                    onChange={handleChange}
                    className="h-50"
                  >
                    <MenuItem value="None">None</MenuItem>
                    {csvFileRecords[0].map((item) => (
                      <MenuItem
                        value={item}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>  
            <div className="d-flex mx-4 my-3 justify-content-between">
              <div>Fee</div>
              <div>
                <FormControl sx={{ width: 200 }} defaultValue={0}>
                  <InputLabel id="demo-simple-select-label">Fee</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="fee"
                    name="fee"
                    onChange={handleChange}
                  >
                    <MenuItem value="None">None</MenuItem>
                    {csvFileRecords[0].map((item) => (
                      <MenuItem
                        value={item}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>      
            <div className="d-flex mx-4 my-3 justify-content-between">
              <div>Note</div>
              <div>
                <FormControl sx={{ width: 200 }} defaultValue={0}>
                  <InputLabel id="demo-simple-select-label">Note</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Name"
                    name="note"
                    onChange={handleChange}
                  >
                    <MenuItem value="None">None</MenuItem>
                    {csvFileRecords[0].map((item) => (
                      <MenuItem
                        value={item}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            
          </div>
        </Modal.Body>
        <Modal.Footer>
        <Button className="import-csv-button" onClick={handleImportCsv}>
          {loading ?
            <><CircularProgress className="file-loader mr-3" /> Uploading </>
            : 'Import Csv/Excel'
          }
        </Button> 
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CsvWithAdvanceOptionSale;
